import Box from "@material-ui/core/esm/Box";
import { nanoid } from 'nanoid';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import getRemovableVehicles, { getRemovableCustomerVehiclesRequestIdState } from 'api/vehicles/getRemovableVehicles';
import { FormElement, AutocompleteAsync } from 'components/Form';
import InfoBox from 'components/InfoBox/InfoBox';
import VehicleInfo from 'components/VehicleInfo/VehicleInfo';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import useUnregisterVehicle from 'hooks/vehicles/unregister/useUnregisterVehicle';
import objectHasValues from 'utils/general/objectHasValues';
import { mapIObeIdWithVehicleToIVehicle } from 'utils/mapping/mapVehicles';
import checkLoadable from 'utils/recoil/checkLoadable';
const idSuffix = nanoid();
export default function ChooseVehicle() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const {
    tagNumber
  } = useParams();
  const {
    state
  } = useLocation();
  const {
    reset,
    resetCurrentVehicle,
    currentVehicle,
    setCurrentVehicle,
    unregisterVehicles,
    isObeBeingMoved
  } = useUnregisterVehicle();
  const setVehicleRequestId = useSetRecoilState(getRemovableCustomerVehiclesRequestIdState);
  const allVehicles = useRecoilValueLoadable(getRemovableVehicles(customer?.id));
  const {
    contents: vehicles,
    loading
  } = checkLoadable(allVehicles);
  useEffect(() => {
    resetCurrentVehicle();
    setVehicleRequestId(prev => prev + 1);
    if (!state?.hasSeveralVehicles) {
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set vehicle if unregister vehicle is accessed from tag details page
  useEffect(() => {
    if (tagNumber && !loading) {
      const v = vehicles?.find(vehicle => vehicle?.obeNumber === tagNumber);
      setCurrentVehicle(v);
    }
  }, [loading, setCurrentVehicle, tagNumber, unregisterVehicles.length, vehicles]);
  const onChange = async (_event, value) => {
    setCurrentVehicle(value);
  };
  const autocompleteInputId = `choose_vehicle_autocomplete_${idSuffix}`;
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(FormElement, {
    title: t('unregister_vehicle.choose_vehicle'),
    childId: autocompleteInputId
  }, /*#__PURE__*/React.createElement(AutocompleteAsync, {
    placeholder: t('vehicles.registration_number'),
    options: vehicles ?? [],
    onChange: onChange,
    optionLabel: "registrationNumber",
    isLoading: loading,
    value: currentVehicle,
    inputId: autocompleteInputId
  }), currentVehicle && objectHasValues(currentVehicle) && /*#__PURE__*/React.createElement(VehicleInfo, {
    vehicle: mapIObeIdWithVehicleToIVehicle(currentVehicle)
  }), isObeBeingMoved && /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('error.is_being_moved'))));
}